import React from "react";
import { useTranslation } from "../../i18n/useTranslation";
import { Typography, Table, Switch, Button } from "antd";

const { Text } = Typography;

const Subscription = () => {
  const { t } = useTranslation();

  const invoiceData = [
    {
      key: "1",
      orderId: "ORD20250601001",
      time: "2025-06-01 18:05",
      amount: "$99.00",
      status: t("statusPaid"),
    },
    {
      key: "2",
      orderId: "ORD20240601001",
      time: "2024-06-01 17:50",
      amount: "$99.00",
      status: t("statusPaid"),
    },
  ];

  const invoiceColumns = [
    { title: t("orderId"), dataIndex: "orderId", key: "orderId" },
    { title: t("orderTime"), dataIndex: "time", key: "time" },
    { title: t("orderAmount"), dataIndex: "amount", key: "amount" },
    {
      title: t("orderStatus"),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span className="inline-block px-2 py-0.5 rounded text-xs bg-green-50 text-green-700">
          {status}
        </span>
      ),
    },
    {
      title: t("orderAction"),
      key: "action",
      render: () => (
        <span>
          <a href="#" className="text-[#1890ff] hover:underline mr-1">
            {t("downloadInvoicePdf")}
          </a>
          <span className="text-gray-300"> | </span>
          <a href="#" className="text-[#1890ff] hover:underline ml-1">
            {t("resendReceiptEmail")}
          </a>
        </span>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-[#004b67]">{t("subscriptionTitle")}</h1>
        <div className="mt-2 h-px bg-[#e6f7ff]" />
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-4">{t("subscriptionPlan")}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("currentPlan")}</Text>
            <Text strong>{t("planPro")}</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("billingCycle")}</Text>
            <Text>{t("billingYearly")}</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("nextBillingTime")}</Text>
            <Text>2026-06-01 18:00 (GMT+8)</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("autoRenew")}</Text>
            <Switch defaultChecked />
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("price")}</Text>
            <Text strong>{t("pricePerYear")}</Text>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-100">
          <Button type="primary">{t("btnRenew")}</Button>
          <Button>{t("btnUpgrade")}</Button>
          <Button>{t("btnDowngrade")}</Button>
          <Button danger>{t("btnCancelSubscription")}</Button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-4">{t("ordersAndInvoices")}</h2>
        <Table
          dataSource={invoiceData}
          columns={invoiceColumns}
          pagination={false}
          size="middle"
        />
      </div>
    </div>
  );
};

export default Subscription;
